import { Vue, Component } from 'vue-property-decorator'
import MainPage from '~/components/page/MainPage'
import s from '~/utils/s'

@Component({
  async fetch ({ store }) {
    await s(store).mainPage.clearBannerData()
    await s(store).mainPage.clearData()
    await Promise.all([
      s(store).mainPage.fillBannerData()
    ])
  }
})
export default class extends Vue {
  render () {
    return <MainPage />
  }
}
